import { IBarcode } from "./IBarcode";

export interface IBarcodes {
    perMeasure: boolean
    codes: IBarcode[]
}

export class Barcodes implements IBarcodes {
    perMeasure: boolean;
    codes: IBarcode[];

    constructor() {
        this.perMeasure = true
        this.codes = []
    }
}
